import { Divider } from '@gto/ui/divider'
import { useMediaQuery } from '@gto/ui/hooks/use-media-query'
import { Typography } from '@gto/ui/typography'

import { SiteLogo } from './site-logo'

export type DealCardHeaderProps = {
  name: string
  site: string
  logo: string | null
}

export const DealCardHeader = ({ name, site, logo }: DealCardHeaderProps) => {
  const isMdAndLower = useMediaQuery('down', 'md')

  return (
    <div className="flex items-center gap-4 bg-paper-elevation5 px-4 py-2 md:gap-2 sm:p-4">
      {isMdAndLower && (
        <SiteLogo
          logo={logo}
          name={name}
        />
      )}
      <div className="flex items-center gap-4 overflow-hidden md:flex-col md:items-start md:gap-0.5">
        <Typography
          className="w-full text-[1.5rem] font-semibold leading-[1.6] md:text-[1.25rem] md:leading-[1.2]"
          variant="h6"
        >
          {name}
        </Typography>
        {Boolean(site) && (
          <>
            <Divider
              flexItem
              orientation="vertical"
            />
            <Typography
              className="font-semibold leading-[1]"
              color="text.secondary"
              variant="subtitle3"
            >
              {site}
            </Typography>
          </>
        )}
      </div>
    </div>
  )
}
